import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

export const StyledMockupWrapper = styled('div')({
  ...mainPreviewContainerStyles,

  flexDirection: 'column',
  gap: '16px',
  padding: '0 12px',
  justifyContent: 'center',
  alignItems: 'center',

  color: COLORS.black,
});

export const StyledIconWrapper = styled('div')({
  height: '70px',

  color: COLORS.black,
  fontSize: '70px',
});

export const StyledButtonsWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
});

export const StyledButton = styled('div')({
  width: '50%',
  height: '40px',
  maxWidth: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  color: COLORS.black,
  border: '1px solid #000',
  borderRadius: '4px',
});
